export default class UserType {
  static 1 = 'Basic'
  static 2 = 'Premium'
  static 3 = 'Super Admin'
  static 4 = 'AppSumo (Tier 1)'
  static 5 = 'AppSumo (Tier 2)'
  static 6 = 'Premium Admin Account (Quarterly)'
  static 7 = 'AppSumo (Tier 3)'
  static 8 = 'AppSumo (Tier 1A)'
  static 9 = 'AppSumo (Tier 2A)'
  static 10 = 'AppSumo (Tier 3A)'
  static 11 = 'Starter - Legacy'
  static 12 = 'Starter'
  static 13 = 'Starter - A'
  static 14 = 'Premium - A'
  static 15 = 'Premium Plus'
  static 16 = 'Premium v2'
  static 17 = 'Premium Plus v2'
  //static 18 = learner
  static 19 = 'AppSumo (Tier 4)'
  static 20 = 'AppSumo (Tier 5)'
  static 21 = 'Elite'
  static 22 = 'AppSumo (Tier 6)'
  static 23 = 'AppSumo (Tier 7)'
  static 24 = 'Pro'
  static 27 = 'Essentials'
  static 28 = 'Growth'
  static 29 = 'Standard'
  static 30 = 'Scale'
  static 31 = 'Enterprise'
  static 32 = 'AppSumo (Tier 8)'
  // 33/34/35 = CreatorPlus / CreatorPro / Launch in
  // mcg-backend-net src/Domain/Enums/RoleType.cs.
  static 33 = 'Plus'
  // 'Pro v2' is the new creator plan. Role 24 is the unrelated legacy 'Pro',
  // which many feature gates still match on by name — keep them distinct.
  static 34 = 'Pro v2'
  static 35 = 'Launch'
  static 36 = 'AppSumo (Tier 9)'

  static getRoleName = role => {
    if (role == null || role === '') return ''

    if (typeof role === 'number') {
      return this[role] || ''
    }

    if (typeof role === 'string' && /^\d+$/.test(role)) {
      return this[Number(role)] || ''
    }

    return role
  }

  static isTrialEquivalent = role => {
    const roleName = this.getRoleName(role)
    return roleName === 'Trial' || roleName === 'Standard'
  }

  static getDisplayRoleName(role) {
    const roleName = this.getRoleName(role)
    if (roleName === 'Standard') return 'Trial'
    if (roleName === 'Pro v2') return 'Pro'
    return roleName
  }

  static isAppSumoUser = role => {
    const roleName = this.getRoleName(role)
    return roleName?.startsWith('AppSumo')
  }

  // AppSumo Tier 9 has 1 teammate seat (backend GetMaxShopMembers).
  static hasTeamSeats = role => {
    const roleName = this.getRoleName(role)
    return (
      roleName === 'Growth' ||
      roleName === 'Scale' ||
      roleName === 'Enterprise' ||
      roleName === 'AppSumo (Tier 9)'
    )
  }

  // Collaboration is included in every paid plan, so only Basic and trials are
  // gated. Both the settings page and its nav badge must ask this, or they drift.
  static hasCollaboration = role => {
    const roleName = this.getRoleName(role)
    return roleName !== 'Basic' && !this.isTrialEquivalent(roleName)
  }

  // Certifications start at Pro v2. Basic never had them, and Plus is the one
  // paid plan that excludes them.
  static hasCertifications = role => {
    const roleName = this.getRoleName(role)
    return roleName !== 'Basic' && roleName !== 'Plus'
  }

  // AI course translation starts at Pro v2, so Plus and the entry legacy/AppSumo
  // tiers are gated. Same cohort as invitation-only access (Badge type 2).
  static COURSE_TRANSLATION_PLANS = new Set([
    'Premium Plus',
    'Premium Plus v2',
    'Premium - A',
    'AppSumo (Tier 3)',
    'AppSumo (Tier 3A)',
    'AppSumo (Tier 4)',
    'AppSumo (Tier 5)',
    'AppSumo (Tier 6)',
    'AppSumo (Tier 7)',
    'AppSumo (Tier 8)',
    'AppSumo (Tier 9)',
    'Elite',
    'Pro',
    'Pro v2',
    'Launch',
    'Essentials',
    'Growth',
    'Scale',
    'Enterprise',
    'Super Admin',
  ])

  static hasCourseTranslation = role => {
    const roleName = this.getRoleName(role)
    return (
      this.COURSE_TRANSLATION_PLANS.has(roleName) ||
      this.isTrialEquivalent(roleName)
    )
  }

  // Dynamic SCORM export now starts at Pro v2 (it used to start at Launch), so
  // Basic, trials and Plus are the gated cohort. The share popover's SCORM tab
  // and its upsell badge must ask this, or they drift.
  static SCORM_EXPORT_PLANS = new Set([
    'Premium Plus',
    'Premium Plus v2',
    'Elite',
    'AppSumo (Tier 3)',
    'AppSumo (Tier 3A)',
    'AppSumo (Tier 4)',
    'AppSumo (Tier 5)',
    'AppSumo (Tier 6)',
    'AppSumo (Tier 7)',
    'AppSumo (Tier 8)',
    'AppSumo (Tier 9)',
    'Pro v2',
    'Launch',
    'Growth',
    'Scale',
    'Enterprise',
  ])

  static hasScormExport = role =>
    this.SCORM_EXPORT_PLANS.has(this.getRoleName(role))
}
